var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Children, useState, useCallback, useMemo, useEffect } from "react";
import { Tab } from "./tab";
export var useBuildTabs = function (children, activeIndex, onChange) {
    return useMemo(function () {
        var indeces = [];
        var nav = [];
        var content = null;
        var firstActiveIndex = -1;
        var activeIsDisabled = false;
        Children.forEach(children, function (tab, index) {
            var props = (tab === null || tab === void 0 ? void 0 : tab.props) || {};
            if (firstActiveIndex < 0 && !props.disabled)
                firstActiveIndex = index;
            var isActive = activeIndex === indeces.length;
            var key = "".concat(index, "-").concat(props.label);
            if (tab) {
                nav.push(React.createElement(Tab, __assign({ key: key }, props, { onChange: onChange, index: index, active: isActive })));
            }
            if (isActive) {
                activeIsDisabled = !!props.disabled;
                content = props.children;
            }
            indeces.push(index);
        });
        return [nav, content, firstActiveIndex, activeIsDisabled];
    }, [children, activeIndex, onChange]);
};
export var useSetActive = function (selected, onChange) {
    if (selected === void 0) { selected = 0; }
    var _a = useState(onChange ? selected : 0), activeIndex = _a[0], setActiveIndex = _a[1];
    var setActive = useCallback(function (index) {
        if (onChange) {
            onChange(index);
            return;
        }
        setActiveIndex(index);
    }, [onChange]);
    useEffect(function () {
        setActiveIndex(selected || 0);
    }, [selected]);
    return [activeIndex, setActive];
};
